import { useContext } from 'react'
import { ReplaySessionContext } from '../context/ReplaySessionContext'

import '../../workspace/css/workspace.scss'

export default function ReplayTaskDescription() {
  
  // Consume the task directly from the session context
  const { session } = useContext(ReplaySessionContext)
  const task = session?.task

  return (
    <div className="ws-content-section">
      <h3 className="ws-section-title">Task Description</h3>
      <div className="ws-description-box">
        {task || <span style={{color: '#999', fontStyle: 'italic'}}>No task description available.</span>}
      </div>
    </div>
  )
}